import { QueryParamsTypes, QueryParamsActionTypes } from "./queryParamsTypes";
import { QueryParamsData } from "./queryParamsTypes";

export function getQueryParams(route: string): QueryParamsActionTypes {
	return {
		type: QueryParamsTypes.GET_QUERY_PARAMS,
		payload: { route },
	};
}

export function saveQueryParams(data: QueryParamsData | null, route: string): QueryParamsActionTypes {
	return {
		type: QueryParamsTypes.SAVE_QUERY_PARAMS,
		payload: { data, route },
	};
}

export function resetReducerQueryParams(): QueryParamsActionTypes {
	return {
		type: QueryParamsTypes.RESET_REDUCER_QUERY_PARAMS,
	};
}
